export const MAX_TICKET_RECORDS = 50

export interface JiraTicketProject {
  key: string
  name: string
}

/* `id` is null for values Jira gives no id, such as labels. */
export interface JiraOption {
  id: string | null
  name: string
}

export interface JiraOptions {
  values: JiraOption[]
}

/* Jira's create-meta `schema`, passed through unchanged. `custom` names the plugin type of a custom field. */
export interface JiraFieldSchema {
  type: string
  items?: string
  system?: string
  custom?: string
  customId?: number
}

/* One field of Jira's create form; `allowed_values` and `schema` are Jira's own shapes. */
export interface JiraCreateField {
  id: string
  label: string
  required: boolean
  schema: JiraFieldSchema
  allowed_values: Record<string, any>[] | null
  default_value: any
  has_search: boolean
}

export interface JiraAssignableUser {
  account_id: string
  display_name: string
  email: string | null
}

/* `warning` says why the list is empty when Jira refuses to share it. */
export interface JiraAssignableUsers {
  values: JiraAssignableUser[]
  warning: string | null
}

export interface CreateTicketPayload {
  metric_slug: string
  project_key: string
  issue_type_id: string
  summary: string
  description?: string | null
  /* Keyed by Jira field id, each value already in the form Jira expects. */
  fields: Record<string, any>
  records: { ids: string[] }
}

export interface TicketCreated {
  key: string
  url: string | null
  csv_attached: boolean
  warning: string | null
}
